import { render, staticRenderFns } from "./ReceivableEdit.vue?vue&type=template&id=3b171636&scoped=true&"
import script from "./ReceivableEdit.vue?vue&type=script&lang=js&"
export * from "./ReceivableEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b171636",
  null
  
)

export default component.exports